// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Sentry.io
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

const ENV = process.env.NODE_ENV.trim()
const monitoredEnvs = [ 'main', 'development' ]
if (monitoredEnvs.includes(ENV)) {
  console.debug(`Sentry monitoring: ${ENV}`)
  Sentry.init({
    dsn: 'https://67d7be728a594fd3a284bd942369f2a3@sentry.io/2640365',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    environment: ENV
  })
} else {
  console.debug(`Skipping sentry.io for env: ${ENV}`)
}

// Cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// Router
import router from './router'

// Google Analytics
import VueAnalytics from 'vue-analytics'
import GaConfig from '@/constants/GoogleAnalyticsConfig.js'
Vue.use(VueAnalytics, {
  id: GaConfig.GA_TRACKING_CODE,
  router
})

// Flash message
import FlashMessage from '@/components/FlashMessage.vue'
Vue.component('flash-message', FlashMessage)

// Vuetify
import Vuetify from 'vuetify'
Vue.use(Vuetify)
require('vuetify/dist/vuetify.min.css')
require('vuetify/src/stylus/app.styl')
require('./stylus/northwestern.styl')

import App from './App'

// Cookie
import VueResource from 'vue-resource'
Vue.use(VueResource)

// include credentials with requests.
Vue.http.interceptors.push((request, next) => {
  request.headers['Content-Type'] = 'application/json'
  request.credentials = true
  next()
})

// Events Service (global Vue instance for emitting events)
import eventService from '@/services/EventService'
Vue.use(eventService)

// Sync Store
import store from '@/store/Store'
Vue.use(store)

// Room Service
import teamService from '@/services/TeamService'
Vue.use(teamService)

// Sync Service
import syncService from '@/services/SyncService'
Vue.use(syncService)

// Room Service
import roomService from '@/services/RoomService'
Vue.use(roomService)

// Report Service
import reportService from '@/services/ReportService'
Vue.use(reportService)

Vue.config.mainTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js